var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ fontSize: _vm.fontSize + 'px' })},[_vm._v(_vm._s(_vm.units)+", "+_vm._s(_vm.cents))])])}
var staticRenderFns = []

export { render, staticRenderFns }